import { GetDynamics as DLGetDynamics, SetDynamic as DLSetDynamic } from './../../../DL/Admin/Dashboard/Dynamics'
import { GetSessionData, UpdateSessionData } from './../../Sessions'


const GetDynamics = async () => {
    try {
        const response = await DLGetDynamics()

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        
    }
}

const SetDynamic = async (idDynamic, triviaId = null) => {
    try {
        if (!idDynamic) {
            return { success: false, message: 'No ha sido posible mostrar esta opción o dinámica al aficionado. Inténtalo nuevamente o inténtalo más tarde.' }
        }
        
        if (isNaN(idDynamic)) {
            return { success: false, message: 'No ha sido posible mostrar esta opción o dinámica al aficionado. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const response = await DLSetDynamic(idDynamic, triviaId)
        
        if (response.success) {
            const responseData = await GetSessionData(true)
            
            if (responseData.success) {
                if (idDynamic === 3 || idDynamic === 4 || idDynamic === 5 || idDynamic === 6 || idDynamic === 10 || idDynamic === 13) {
                    // Guarda la info de la trivia o quizz
                    responseData.data.dynamic = response.data
                } else {
                    const dynamic = responseData?.data?.dynamic

                    if (dynamic) {
                        // Borra la info de la trivia o quizz
                        responseData.data.dynamic = null
                    }
                }
                
                await UpdateSessionData(responseData.data, true)
            } else {
                // Guarda la info de la trivia o quizz
                if (idDynamic === 3 || idDynamic === 4 || idDynamic === 5 || idDynamic === 6 || idDynamic === 10 || idDynamic === 13) {
                    const admData = {
                        dynamic: response.data
                    }
                    
                    await UpdateSessionData(admData, true)
                }
            }

            // Guarda la info de la trivia o quizz
            // if (idDynamic === 3) {
            //     const responseData = await GetSessionData(true)
    
            //     if (responseData.success) {
            //         responseData.dynamic = response.data
            //         await UpdateSessionData(responseData, true)
            //     }
            // } else {
            //     // Borra la info de la trivia o quizz
            //     const responseData = await GetSessionData(true)

            //     if (responseData.success) {
            //         const dynamic = responseData.dynamic

            //         if (dynamic) {
            //             responseData.dynamic = null
            //             await UpdateSessionData(responseData, true)
            //         }
            //     }
            // }

            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        
    }
}

const GetDynamicData = async () => {
    try {
        const response = await GetSessionData(true)
    
        if (response.success) {
            const dynamic = response?.data?.dynamic

            if (dynamic) {
                return { success: true, data: dynamic }
            } else {
                return { success: false, message: 'No ha sido posible obtener la información de la trivia. Intenta actualizar la página o intenta actualizarla más tarde.' }
            }
        } else {
            return { success: false, message: 'No ha sido posible obtener la información de la trivia. Intenta actualizar la página o intenta actualizarla más tarde.' }
        }
    } catch (error) {
        
    }
}

const DeleteDynamicData = async () => {
    try {
        const response = await GetSessionData(true)
        
        if (response.success) {
            const dynamic = response?.data?.dynamic
            
            if (dynamic) {
                response.data.dynamic = null
                
                const responseData = await UpdateSessionData(response.data, true)
                
                if (responseData.success) {
                    return { success: true, data: null }
                } else {
                    return { success: false, message: '' }
                }
            } else {
                //return { success: false, message: '' }
                return { success: true, data: null } // Está bien porque ya no existe la info que va a borrar
            }
        } else {
            return { success: true, data: null } // Está bien porque ya no existe la info que va a borrar
        }
    } catch (error) {
        return { success: false, message: '' }
    }
}

// const UpdateDynamic = async (dynamicData) => {
//     try {
//         debugger
//         if (!dynamicData.id) {
//             return { success: false, message: '' }
//         }

//         if (!isNaN(dynamicData.id)) {
//             return { success: false, message: '' }
//         }

//         if (dynamicData.id === '') {
//             return { success: false, message: '' }
//         }
        
//         if (dynamicData.field === '') {
//             return { success: false, message: '' }
//         }
        
//         if (dynamicData.value === undefined || dynamicData.value === null) {
//             return { success: false, message: '' }
//         }
//         debugger
//         const response = await DLUpdateDynamic(dynamicData.id, dynamicData.field, dynamicData.value)
//         debugger
//         if (response.success) {
//             return { success: true, data: response.data }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
        
//     }
// }

export { GetDynamics, SetDynamic, GetDynamicData, DeleteDynamicData };